// SVG wave divider — pass top (surface color above wave) and bottom (surface color below wave)
// Uses inline CSS colors so wave can bridge any two brand-neutral sections.
export default function WaveDivider({ from = "#ffffff", to = "#f8fafc", flip = false, className = "" }) {
  return (
    <div className={`relative overflow-hidden ${className}`} style={{ background: to }} aria-hidden="true">
      <svg
        viewBox="0 0 1440 60"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        className="wave-divider"
        style={flip ? { transform: "scaleY(-1)" } : undefined}
      >
        <path
          d="M0,32 C240,60 480,0 720,20 C960,40 1200,60 1440,28 L1440,0 L0,0 Z"
          fill={from}
        />
      </svg>
    </div>
  );
}
